import { render, staticRenderFns } from "./CollectionWeek.vue?vue&type=template&id=c285602a&"
import script from "./CollectionWeek.vue?vue&type=script&lang=js&"
export * from "./CollectionWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports